import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Switch from 'react-switch';

const propTypes = {
  visible: PropTypes.bool,
  album: PropTypes.shape({
    id: PropTypes.string,
  }),
  qrCode: PropTypes.shape({
    isEnabled: PropTypes.bool,
    withReviewPhotos: PropTypes.bool,
  }),
  onUpdateQRCode: PropTypes.func.isRequired,
};
const SecondaryQRCodeView = ({ visible, qrCode, onUpdateQRCode }) => {
  const { isEnabled: enabled, withReviewPhotos: withReview } = qrCode ?? {};
  const [withQRCode, setWithQRCode] = useState(enabled);
  const [withReviewPhotos, setWithReviewPhotos] = useState(withReview);
  const [isFirstRender, setIsFirstRender] = useState(true);

  useEffect(() => {
    if (!isFirstRender && visible) {
      onUpdateQRCode({
        withLogo: false,
        logo: undefined,
        withCallout: true,
        enabled: withQRCode,
        withReviewPhotos,
      });
    }
  }, [withQRCode, withReviewPhotos]);

  useEffect(() => {
    if (enabled) {
      setWithQRCode(true);
      setWithReviewPhotos(withReview);
    }
  }, [enabled, visible]);

  useEffect(() => {
    setIsFirstRender(false);
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <div className="w-100">
      <div className="text-extra-bold text-dark d-flex w-100 justify-content-between align-items-center mb-2">
        Insert QR code
        <Switch
          uncheckedIcon={false}
          checkedIcon={false}
          height={20}
          width={40}
          onColor="#7ace21"
          offColor="#cdd6e4"
          className="pl-1"
          onChange={() => setWithQRCode(prev => !prev)}
          checked={withQRCode}
        />
      </div>
      {withQRCode && (
        <div className="w-100 mt-2">
          <div className="text-extra-bold text-dark d-flex w-100 justify-content-between">
            Review photos before adding to slideshow
            <Switch
              uncheckedIcon={false}
              checkedIcon={false}
              height={20}
              width={40}
              onColor="#7ace21"
              offColor="#cdd6e4"
              className="pl-2"
              onChange={() => setWithReviewPhotos(prev => !prev)}
              checked={withReviewPhotos}
            />
          </div>
          <p className="text-xs text-light pr-3 mb-0">
            You will receive a text when there are photos to be reviewed.
          </p>
        </div>
      )}
    </div>
  );
};

SecondaryQRCodeView.propTypes = propTypes;

export default SecondaryQRCodeView;
